import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/lib/company";
import QuickDemoDialog from "@/components/QuickDemoDialog";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/courses", label: "Courses" },
  { to: "/pay-demo", label: "Book a Demo" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full bg-white/85 backdrop-blur-xl border-b border-slate-200"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <div className="h-9 w-9 grid place-items-center bg-[#0052FF] text-white font-display font-bold">
            H
          </div>
          <div className="leading-tight">
            <div className="font-display text-[15px] font-bold tracking-tight">{COMPANY.name}</div>
            <div className="text-[10px] text-slate-500 uppercase tracking-widerest font-mono-plex">
              IT Training & Consultancy
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "text-[#0052FF]"
                    : "text-slate-700 hover:text-slate-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to="/pay-demo"
            data-testid="header-cta-pay-demo"
            className="inline-flex items-center gap-1.5 bg-[#0052FF] hover:bg-[#0040CC] text-white text-sm font-medium px-4 py-2 transition-colors"
          >
            Pay ₹500 & book demo <ArrowUpRight className="w-4 h-4" />
          </Link>
          <QuickDemoDialog testIdPrefix="header-quick-demo">
            <button
              type="button"
              data-testid="header-cta-contact-demo"
              className="inline-flex items-center gap-1.5 border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white text-sm font-medium px-4 py-2 transition-colors"
            >
              Contact
            </button>
          </QuickDemoDialog>
        </div>

        <button
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="flex flex-col p-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm border-b border-slate-100 ${
                    isActive ? "text-[#0052FF] font-medium" : "text-slate-800"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/pay-demo"
              onClick={() => setOpen(false)}
              className="mt-3 bg-[#0052FF] text-white text-center px-4 py-3 text-sm font-medium"
              data-testid="mobile-cta-pay-demo"
            >
              Pay ₹500 & book demo
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
